import "./TermsOfService.css";

function TermsOfService() {
  return (
    <div className="termsofservice">
      <h1>London Mapped</h1>
      <h2>London Mapped Terms of Service</h2>

<p>Last updated: 01 September 2026<br></br><br></br>

These Terms of Service ("Terms") govern your use of the London Mapped application ("London Mapped", "the App", "we", "us", or "our"), which is developed and operated by an independent developer.<br></br><br></br>

By creating an account or using London Mapped, you agree to these Terms. If you do not agree with these Terms, please do not use the App.</p>

<h3>1. About London Mapped</h3>

<p>London Mapped is a restaurant and pub discovery application designed to help users discover places to eat and drink in London.<br></br><br></br>

The App allows users to:<br></br><br></br>

Browse and discover restaurants and pubs;<br></br>
View information and reviews about places;<br></br>
Save places as favourites;<br></br>
Add places to a personal wishlist; and<br></br>
Access other features that we may introduce in the future.<br></br><br></br>

London Mapped is currently intended for users in the United Kingdom.</p>

<h3>2. Your Account</h3>

<p>Some features of London Mapped require you to create an account.<br></br><br></br>

You are responsible for:<br></br><br></br>

Providing accurate information when creating your account;<br></br>
Keeping your account credentials secure;<br></br>
Not sharing your account with another person; and<br></br>
All activity carried out through your account.<br></br><br></br>

You must not use another person's account without their permission.<br></br><br></br>

We reserve the right to suspend or terminate accounts where we reasonably believe that an account is being used in violation of these Terms, unlawfully, fraudulently, or in a way that could harm the App or other users.</p>

<h3>3. Acceptable Use</h3>

<p>When using London Mapped, you agree not to:<br></br><br></br>

Use the App for unlawful purposes;<br></br>
Attempt to gain unauthorised access to the App, its systems, or another user's account;<br></br>
Interfere with or disrupt the operation of the App;<br></br>
Attempt to reverse engineer, decompile, or otherwise improperly access the App's underlying code;<br></br>
Use automated systems to scrape or collect information from the App without our permission;<br></br>
Impersonate another person or misrepresent your identity; or<br></br>
Use the App in a way that could damage, disable, overburden, or impair the service.</p>

<h3>4. Restaurant and Pub Information</h3>

<p>London Mapped provides information about restaurants, pubs, and other places of interest.<br></br><br></br>

We aim to provide useful and accurate information, but we cannot guarantee that all information displayed in the App will always be complete, accurate, or up to date.<br></br><br></br>

Information such as:<br></br><br></br>

Opening hours;<br></br>
Menus;<br></br>
Prices;<br></br>
Addresses;<br></br>
Availability;<br></br>
Services;<br></br>
Reviews; and<br></br>
Other venue information<br></br><br></br>

may change without notice.<br></br><br></br>

You should verify important information directly with the relevant restaurant or pub before relying on it.<br></br><br></br>

London Mapped does not guarantee that a particular restaurant or pub will be open, available, accepting customers, or offering any particular menu, service, or price.</p>

<h3>5. Reviews and User Content</h3>

<p>If London Mapped introduces features allowing users to submit reviews, photographs, or other content, additional rules may apply.<br></br><br></br>

You must only submit content that you have the right to share and must not submit content that is unlawful, misleading, abusive, defamatory, discriminatory, or infringes another person's rights.<br></br><br></br>

We reserve the right to remove content that we reasonably believe violates these Terms or is otherwise inappropriate for London Mapped.<br></br><br></br>

<h3>6. Intellectual Property</h3>

<p>The London Mapped application, including its design, branding, logos, graphics, software, and original content, is owned by or licensed to the London Mapped team and is protected by applicable intellectual property laws.<br></br><br></br>

You may use London Mapped for your personal, non-commercial use in accordance with these Terms.<br></br><br></br>

You may not copy, reproduce, modify, distribute, sell, or commercially exploit the App or its content without our prior permission.</p>

<h3>7. Availability of the App</h3>

<p>We aim to keep London Mapped available and functioning reliably, but we do not guarantee that the App will always be available, uninterrupted, or free from errors.<br></br><br></br>

We may modify, suspend, restrict, or discontinue parts of the App at any time, including for maintenance, security, technical, or other operational reasons.</p>

<h3>8. Third-Party Services</h3>

<p>London Mapped uses third-party services, including Supabase, to provide certain functionality such as account authentication and database services.<br></br><br></br>

Your use of London Mapped may therefore be subject to the terms and policies of those third-party services where applicable.<br></br><br></br>

<h3>9. No Guarantees</h3>

</p>London Mapped is provided on an "as available" basis.<br></br><br></br>

To the extent permitted by law, we do not guarantee that:<br></br><br></br>

The App will meet every user's requirements;<br></br>
Information within the App will always be accurate or current;<br></br>
The App will always be available or error-free; or<br></br>
Any restaurant or pub listed in the App will provide a particular experience, service, product, or level of quality.<br></br><br></br>

London Mapped is a discovery and information service and does not operate or control the restaurants and pubs listed within the App.<br></br><br></br>

<h3>10. Limitation of Liability</h3>

<p>To the maximum extent permitted by applicable law, Hadley Long will not be responsible for losses or damages arising from your use of London Mapped where those losses or damages could not reasonably have been anticipated.<br></br><br></br>

Nothing in these Terms excludes or limits liability where doing so would be unlawful, including liability that cannot legally be excluded or limited under UK law.</p>

<h3>11. Account Termination</h3>

<p>You may stop using London Mapped at any time.<br></br><br></br>

You may also delete your account using the account deletion functionality provided within the App.<br></br><br></br>

We may suspend or terminate your access to London Mapped if you materially breach these Terms or use the App in a way that is unlawful, fraudulent, abusive, or harmful to the App or its users.</p>

<h3>12. Privacy</h3>

<p>Our collection and use of personal information is described in our Privacy Policy.<br></br><br></br>

You can read our Privacy Policy here:<br></br><br></br>

https://placesmapped.co.uk/#/privacypolicy </p>

<h3>13. Changes to These Terms</h3>

We may update these Terms from time to time as London Mapped develops or as applicable laws and requirements change.<br></br><br></br>

When we make changes, we will update the "Last updated" date at the top of these Terms.<br></br><br></br>

Your continued use of London Mapped after updated Terms become effective means that you accept the updated Terms.</p>

<h3>14. Governing Law</h3>

<p>These Terms are governed by the laws of England and Wales.<br></br><br></br>

Any disputes relating to these Terms or your use of London Mapped will be subject to the jurisdiction of the courts of England and Wales, subject to any mandatory rights you may have under applicable consumer protection law.</p>

<h3>15. Contact</h3>

<p>If you have any questions about these Terms or London Mapped, please contact:<br></br><br></br>

London Mapped
United Kingdom
Email: hadley.long.dev@gmail.com

London Mapped
United Kingdom</p>
    </div>
  );
}

export default TermsOfService;